<template>
    <div>
        <v-dialog v-model="isOpenResources" persistent max-width="1000px">
            <v-card elevation="0" outline>
                <v-card-title primary-title>
                    <v-row>
                        <v-col cols="12" align="start">
                            <div
                                v-if="$vuetify.breakpoint.mdAndDown"
                                class="primary--text text-overline text-center"
                            >
                                Recursos para descargar
                            </div>
                            <div
                                v-else
                                class="
                                    font-weight-light
                                    primary--text
                                    text-h5 text-capitalize
                                    mt-n1
                                    d-flex
                                    align-center
                                "
                            >
                                <v-icon large left>
                                    mdi-smart-card-outline
                                </v-icon>
                                Recursos para descargar
                            </div>
                        </v-col>
                    </v-row>
                </v-card-title>
                <!-- <v-divider class="test"></v-divider> -->

                <v-tabs
                    class="px-8"
                    v-if="!isLoadingResources"
                    v-model="tab"
                    icons-and-text
                    show-arrows
                    fixed-tabs
                >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab @click="tab = 0">
                        Recursos
                        <v-icon>mdi-semantic-web</v-icon>
                    </v-tab>

                    <v-tab @click="tab = 1">
                        Comunicados
                        <v-icon>mdi-account-tie-voice</v-icon>
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <!-- RESOURCES -->
                    <v-tab-item>
                        <v-card-text
                            v-if="isLoadingResources"
                            class="d-flex justify-center mt-6"
                        >
                            <v-progress-circular
                                :size="60"
                                color="primary"
                                indeterminate
                            ></v-progress-circular>
                        </v-card-text>
                        <v-card-text v-else class="pa-4">
                            <div>
                                <v-row>
                                    <v-col
                                        v-for="(url, name) in resourcesData"
                                        :key="name"
                                        cols="12"
                                        md="3"
                                    >
                                        <v-item v-slot="{ active, toggle }">
                                            <v-card
                                                flat
                                                class="align-center"
                                                color="primary accent-3"
                                                dark
                                                align="center"
                                                height="130"
                                                @click="downloadResource(url)"
                                            >
                                                <v-row align="center">
                                                    <v-col
                                                        cols="12"
                                                        justify="center"
                                                    >
                                                        <v-icon size="60">
                                                            {{ getIcon(name) }}
                                                        </v-icon>
                                                    </v-col>
                                                </v-row>
                                                <v-row
                                                    class="
                                                        grey-color
                                                        overline
                                                        flex-grow-1
                                                        text-center
                                                    "
                                                >
                                                    <v-col cols="12">
                                                        {{
                                                            name
                                                                .replaceAll(
                                                                    '_',
                                                                    ' '
                                                                )
                                                                .toUpperCase()
                                                        }}
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </v-item>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card-text>
                    </v-tab-item>
                    <!-- RELEASES -->
                    <v-tab-item>
                        <v-card-text
                            v-if="isLoadingResources"
                            class="d-flex justify-center mt-6"
                        >
                            <v-progress-circular
                                :size="60"
                                color="primary"
                                indeterminate
                            ></v-progress-circular>
                        </v-card-text>
                        <div v-else>
                            <div>
                                <v-data-table
                                    class="elevation-0"
                                    :headers="headers"
                                    :items="releasesData"
                                    hide-default-footer
                                >
                                    <template v-slot:item.title="{ item }">
                                        <div>
                                            <v-icon class="mr-2">
                                                mdi-bullseye-arrow
                                            </v-icon>
                                            {{ item.title }}
                                        </div>
                                    </template>
                                    <template v-slot:item.href="{ item }">
                                        <div class="font-weight-medium">
                                            <v-btn
                                                class="
                                                    mr-lg-2 mr-md-0
                                                    mb-md-2
                                                    mt-md-1
                                                "
                                                icon
                                                @click="
                                                    downloadResource(item.href)
                                                "
                                            >
                                                <v-icon color="primary">
                                                    mdi-eye
                                                </v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                </v-data-table>
                            </div>
                        </div>
                    </v-tab-item>
                </v-tabs-items>

                <v-card-actions class="d-flex justify-end">
                    <v-btn text color="red" @click="closeDialog" class="mr-2">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    components: {},
    name: 'ResourcesView',
    data: () => ({
        tab: 0,
        icons: {
            oferta_comercial: 'mdi-file-document-multiple-outline',
            resumen_tarifas: 'mdi-notebook-multiple',
            comparador_masmovil: 'mdi-compare',
            comparador_yoigo: 'mdi-compare',
            dispositivos: 'mdi-devices',
            dispositivos_libres: 'mdi-cellphone-sound',
            accesorios: 'mdi-sale',
            renuevo: 'mdi-autorenew',
        },
        headers: [
            {
                text: 'Titulo',
                align: 'start',
                value: 'title',
            },
            { text: 'Fecha', value: 'date', align: 'center' },
            { text: 'Visualizar', value: 'href', align: 'center' },
        ],
    }),
    methods: {
        downloadResource(url) {
            window.open(url, '_blank');
        },
        closeDialog() {
            this.$store.commit('resources/isOpenResources', false);
        },
        getIcon(name) {
            try {
                return this.icons[name];
            } catch (e) {}
        },
        ...mapActions('resources', ['getResources', 'getReleases']),
    },
    computed: {
        isOpenResources: {
            get: function () {
                return this.$store.state.resources.resources.isOpenResources;
            },
            set: function (val) {
                this.$store.commit('resources/isOpenResources', val);
            },
        },
        ...mapState('resources', {
            resourcesData: (state) => state.resources.resourcesData,
            releasesData: (state) => state.resources.releasesData,
            isLoadingResources: (state) => state.resources.isLoadingResources,
            isOpenResources: (state) => state.resources.isOpenResources,
        }),
    },
    watch: {
        isOpenResources: {
            immediate: true,
            handler(newValue, oldValue) {
                if (newValue) {
                    this.$store.commit('resources/isLoadingResources', true);
                    this.getReleases();
                    this.getResources().then(() => {
                        this.$store.commit(
                            'resources/isLoadingResources',
                            false
                        );
                    });
                }
            },
        },
    },
};
</script>

<style scoped>
</style>